module.exports = __webpack_public_path__ + "img/drive-dil-4.ab3fc2bc.svg";